<template>
   <div>
       <!-- Header section -->
       <header class="header-section-team header-section">
           <div class="container text-right">
               <div class="page-info">
                   <h2>За нас</h2>
                   <div class="page-links">
                       <router-link to="/">Начало</router-link>
                       <span class="active">За нас</span>
                   </div>
               </div>
           </div>
       </header>
       <div class="container mt-5">
           <div class="row">
               <div class="col-md-4">
                   <div class="mb-5">
                       <img :src="user.image" alt="" class="card-img-top">
                   </div>
               </div>
               <div class="col-md-8">
                   <h2>{{ user.name }}</h2>
                   <router-link v-if="userLogedIn" class="btn-lg btn-primary mt-3" :to="{name: 'edit', params: { id: $route.params.id }}">РЕДАКТИРАНЕ</router-link>
                   <p class="mt-4" v-html="user.story"></p>
               </div>
           </div>
       </div>
   </div>
</template>
<script>
    import { db } from '../firebase';

    export default {
        data() {
            return {
                user: {
                }
            }
        },
        computed: {
            userLogedIn () {
                return this.$store.getters.user
            }
        },
        created() {
            let dbRef = db.collection('team').doc(this.$route.params.id);
            dbRef.get().then((doc) => {
                this.user = doc.data();
            }).catch((error) => {
                console.log(error)
            })
        }
    }
</script>
<style>
    .card-img-top {
        border-radius: 20px;
    }
</style>
